const axios = require('axios')
const qs = require('qs')

const search = async queryConfig => {
  const ES_BASE_PATH = process.env.ES_BASE_PATH || '/api/es'
  const CURRENT_BUILD = process.env.GATSBY_CURRENT_BUILD
  try {
    const res = await axios({
      method: 'get',
      url: `${ES_BASE_PATH}/${queryConfig.index}/_search/${
        CURRENT_BUILD || 'de'
      }`,
      params: qs.parse(queryConfig)
    })

    const items = []
    res.data.hits.hits.forEach(item => {
      items.push(item._source)
    })

    return {
      response: res,
      hits: res.data.hits.hits.length,
      result: items
    }
  } catch (e) {
    console.error('Unable to connect to search', e)
    return {}
  }
}

module.exports = search
